import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Catch unhandled promise rejections that originate outside Angular's zone
// (e.g. Pusher WebSocket callbacks, bare .then() chains, third-party scripts).
// Angular's ErrorHandler only receives errors thrown inside the zone; this fills
// the gap so nothing silently swallows a rejection and leaves the UI stuck.
window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  // Prevent the browser from logging a duplicate uncaught error in the console.
  event.preventDefault();
  console.error('[UnhandledRejection]', event.reason);
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
